import { useEffect, useState } from "react";
import { CATEGORIES, CategoryType } from "../assets/data/constants";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/apiClient";

const BestSellerCard = () => {
    const [bestsellers, setBestsellers] = useState<{ 
        '#top'?: { title: string, imgUrl: string, position: number, isbn: string }[], 
        'fictie'?: { title: string, imgUrl: string, position: number, isbn: string }[],
        'non-fictie'?: { title: string, imgUrl: string, position: number, isbn: string }[],
        'spannend'?: { title: string, imgUrl: string, position: number, isbn: string }[],
    }>({});
    const [loading, setLoading] = useState(false);

    const [selectedCategorie, setSelectedCategories] = useState<CategoryType >('#top');
    const navigate = useNavigate();

    const handleBookClick = async (isbn: string) => {
        if (!isbn) {
            if (window.confirm('No ISBN found for this book, add manually?')) {
                navigate(`/add-book`);
            }
            return;
        };

        await axiosInstance.get('/getUserBooks').then((data:any) => {
            const book = data.find((book: any) => book['ISBN13'] === isbn);
            if (book) {
                navigate(`/book/${book['Book Id']}`);
            } else {
                navigate(`/add-book?isbn=${isbn}`);
            }
        })
        
    };

    useEffect(() => {
        getBestSellers();
    }, []);

    const getBestSellers = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://geminiscraper.onrender.com/books/bestsellers/');
            const data = await response.json();
            setBestsellers(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching bestsellers:', error);
        }
    };

    return (
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64">
            <div className="flex gap-2">
                <h1 className="text-2xl font-bold mb-4 text-[#60637A]">
                    Bestseller
                </h1>
                
                <div className=" relative inline-block text-left dropdown z-10">
                    <span className="rounded-md shadow-sm">
                        <button className="inline-flex justify-between min-w-32 w-full px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800" type="button" aria-haspopup="true" aria-expanded="true" aria-controls="headlessui-menu-items-117">
                            <span>{CATEGORIES[selectedCategorie].displayName}</span>
                            <svg className="w-5 h-5 ml-2 -mr-1" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </button>
                    </span>
                    <div className="opacity-0 invisible dropdown-menu transition-all duration-300 transform origin-top-right -translate-y-2 scale-95">
                        <div className="absolute right-0 w-40 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none z-10" aria-labelledby="headlessui-menu-button-1" id="headlessui-menu-items-117" role="menu">
                            <div className="py-1">
                                {Object.values(CATEGORIES).map((categorie, index) => {
                                    if (categorie.id === selectedCategorie) {
                                        return null;
                                    }

                                    return(
                                        <button key={index} className="text-gray-700 w-full flex justify-between px-4 py-2 text-sm leading-5 text-left hover:bg-gray-100 hover:text-gray-900" role="menuitem" onClick={() => setSelectedCategories(categorie.id)}>
                                            <span>{categorie.displayName}</span>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {loading ? 
             <div className="loader"></div> 
        :
            <div className="flex items-center justify-between overflow-x-auto overflow-y-hidden">
                <div className="flex">
                    {bestsellers[selectedCategorie]?.map((bestseller, index) => (
                        <div key={index} className="flex items-center w-32 m-2 relative pointer" onClick={() => handleBookClick(bestseller.isbn)}>
                            <img src={bestseller.imgUrl} alt="Book Cover" className="w-32 h-48 object-cover rounded-xl" />
                            <div className="absolute bottom-0 left-0 right-0 p-2">
                                <p className=" trans-text text-2xl">{bestseller.position}</p>
                            </div>
                        </div>
                    ))}
                </div>                
            </div>
        }
            
        </div>
    );
};export default BestSellerCard;